import 'date-fns'
import React from 'react'
import Grid from '@material-ui/core/Grid'
import DateFnsUtils from '@date-io/date-fns'
import { MuiPickersUtilsProvider, KeyboardTimePicker, KeyboardDatePicker } from '@material-ui/pickers'
import { Icon } from '@material-ui/core'
import { FiCalendar } from 'react-icons/fi'
import moment from 'moment'

export default function CustomDatePicker({ selectedDate, setSelectedDate, defaultValue, maxDate, height }) {
  // The first commit of Material-UI
  // const [] = React.useState(new Date('2014-08-18T21:11:54'))

  const handleDateChange = (date) => {
    //console.log('Date : ', date)
    // if (defaultValue === 'To') {
    //   let endDay = new Date(date)
    //   endDay.setHours(23, 59, 59)
    //   date = endDay
    // }
    setSelectedDate(moment(date).add(330, 'minutes').toISOString())
  }

  return (
    <div
      style={{
        width: '190px',
      }}
    >
      <MuiPickersUtilsProvider utils={DateFnsUtils}>
        {/* <Grid container justify="flex-end"> */}

        <KeyboardDatePicker
          // margin="normal"
          disableToolbar
          id="date-picker-dialog"
          // label="Date of Birth"
          // defaultValue={defaultValue}
          label={defaultValue}
          autoOk={true}
          variant="inline"
          value={selectedDate}
          onChange={handleDateChange}
          format="dd/MM/yyyy"
          //type="time"
          // KeyboardButtonProps={{
          //   'aria-label': 'change date',
          // }}
          // InputProps={{
          //   disableUnderline: true,
          // }}
          // keyboardIcon={
          //   <Icon>
          //     <FiCalendar />
          //   </Icon>
          // }
          // style={{
          //   // border: '1px solid #CCCCCC',
          //   borderRadius: '4px',
          //   padding: '0px 5px 5px 5px',
          //   display: 'flex',
          //   justifyContent: 'center',

          //   height: (height ? height :'45px'),
          // }}
          style={{ width: '90%' }}
          maxDate={maxDate}
        />

        {/* </Grid> */}
      </MuiPickersUtilsProvider>
    </div>
  )
}
// `${defaultValue ? 45 : 32}px`,
